<template>
  <div class="page-shell online-course-page">
    <div class="online-course-app">
      <MobileTopNav title="在线课程" />

      <main class="online-course-main">
        <section class="online-course-hero">
          <div class="hero-board">
            <h1>在线老师一对一</h1>
            <p>[ 足不出户 因材施教 ]</p>
            <small>简单方便，让孩子直接和老师面对面</small>
            <div class="hero-tags">
              <span>15年办学经验</span>
              <span>58同城投资合作</span>
            </div>
          </div>
        </section>

        <section class="online-course-intro">
          <h2>在线一对一模式介绍</h2>
          <p>
            简单方便，让孩子直接和老师面对面<br>
            首先 ----- 专业学科老师分析、诊断孩子学习问题，预约老师，安排试听。<br>
            其次 ----- 电脑或者平板下载客户端。<br>
            最后 ----- 一对一直播上课，制定课程方案，随时观看录播课程，巩固所学内容。
          </p>
          <button
            class="online-course-action"
            type="button"
            @click="goAppointment"
          >
            在线预约
            <i class="el-icon-right"></i>
          </button>
        </section>

        <section class="online-course-advantage">
          <h2>课程优势</h2>
          <div class="advantage-list">
            <article
              v-for="item in advantages"
              :key="item.index"
              class="advantage-card"
            >
              <div class="advantage-index">
                <span>{{ item.index }}</span>
              </div>
              <div class="advantage-content">
                <h3>{{ item.title }}</h3>
                <p>{{ item.desc }}</p>
              </div>
            </article>
          </div>

          <button
            class="online-course-action advantage-action"
            type="button"
            @click="goAppointment"
          >
            在线预约
            <i class="el-icon-right"></i>
          </button>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
import MobileTopNav from '../components/MobileTopNav.vue'

export default {
  name: 'OnlineCourseView',
  components: {
    MobileTopNav
  },
  data() {
    return {
      advantages: [
        {
          index: '1',
          title: '层层把关筛选名师',
          desc: '名师一对一辅导，提前备课，课程内容准备更详细，更有针对性。'
        },
        {
          index: '2',
          title: '足不出户 节约师生时间',
          desc: '打开电脑或者平板，进入直播教室便可上课，节约学生和老师在路上的时间。'
        },
        {
          index: '3',
          title: '师资库更强大 学生选择余地更多',
          desc: '打破空间限制，全国可以选择的名师更多，不再拘泥于学生家附近的机构或者老师上课，可挑选更适合的老师。'
        },
        {
          index: '4',
          title: '安全性更高 师生面对面但接触不到',
          desc: '避免老师学生单独上课产生的潜在问题，让一对一上课安全性更高，家长更放心。'
        },
        {
          index: '5',
          title: '随时观看录播课 效率更高、效果更好',
          desc: '随时随地可以查看录播课程，巩固课堂老师讲过的内容。'
        }
      ]
    }
  },
  mounted() {
    document.title = '在线课程'
  },
  methods: {
    goAppointment() {
      return
      // console.log('预约')
    }
  }
}
</script>

<style scoped>
.online-course-page {
  min-height: 100vh;
  background: #f1f2f4;
}

.online-course-app {
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  overflow: hidden;
  background: #fff;
}

.online-course-main {
  padding-bottom: 64px;
}

.online-course-hero {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 242px;
  overflow: hidden;
  background:
    linear-gradient(90deg, rgba(25, 171, 119, 0.06) 1px, transparent 1px),
    linear-gradient(0deg, rgba(25, 171, 119, 0.06) 1px, transparent 1px),
    #fcfdfb;
  background-size: 28px 28px;
}

.online-course-hero::before,
.online-course-hero::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(25, 171, 119, 0.18);
  filter: blur(1px);
}

.online-course-hero::before {
  top: 86px;
  left: 78px;
  width: 22px;
  height: 22px;
  box-shadow: 296px 10px 0 rgba(25, 171, 119, 0.16);
}

.online-course-hero::after {
  top: 18px;
  left: -18px;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: rgba(25, 171, 119, 0.08);
  transform: rotate(-18deg);
}

.hero-board {
  position: relative;
  z-index: 1;
  width: min(100% - 56px, 380px);
  text-align: center;
}

.hero-board h1 {
  color: #0aa66f;
  font-size: 36px;
  font-weight: 800;
  line-height: 1.18;
  letter-spacing: 1px;
}

.hero-board p {
  margin-top: 14px;
  color: #a66342;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.4;
}

.hero-board small {
  display: block;
  margin-top: 8px;
  color: #a66342;
  font-size: 12px;
}

.hero-tags {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 14px;
}

.hero-tags span {
  min-width: 104px;
  padding: 5px 10px;
  background: #9a6b4a;
  color: #fff;
  font-size: 12px;
  line-height: 1;
}

.online-course-intro {
  padding: 72px 34px 44px;
  background: linear-gradient(180deg, #fbfcff 0%, #fff 100%);
}

.online-course-intro h2,
.online-course-advantage h2 {
  color: #1f2937;
  font-size: 22px;
  font-weight: 500;
  line-height: 1.4;
}

.online-course-intro h2::after {
  content: '';
  display: block;
  width: 42px;
  height: 1px;
  margin-top: 12px;
  background: #222;
}

.online-course-intro p {
  margin-top: 26px;
  color: #7a828d;
  font-size: 18px;
  line-height: 1.95;
  text-align: justify;
}

.online-course-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  width: 176px;
  height: 50px;
  margin: 72px auto 0;
  border: none;
  background: #12af78;
  color: #fff;
  font-size: 16px;
  line-height: 1;
}

.online-course-action i {
  font-size: 26px;
}

.online-course-advantage {
  padding: 0 0 26px;
  background: #f5f5f5;
}

.online-course-advantage h2 {
  display: inline-block;
  margin: 0 0 18px 8px;
  padding: 0 4px 2px;
  background: linear-gradient(180deg, transparent 62%, rgba(242, 164, 171, 0.38) 62%);
  color: #12a875;
  font-size: 25px;
  font-weight: 800;
}

.advantage-list {
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 18px 18px 24px;
}

.advantage-card {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  gap: 10px;
  align-items: flex-start;
  min-height: 138px;
  padding: 28px 24px 24px 22px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 14px rgba(31, 41, 55, 0.06);
}

.advantage-index {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-top: 4px;
  background: #14b87e;
  color: #fff;
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
  transform: rotate(45deg);
}

.advantage-index span {
  display: block;
  font-family: Arial, sans-serif;
  transform: rotate(-45deg);
}

.advantage-content h3 {
  color: #0aa66f;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.55;
}

.advantage-content p {
  margin-top: 6px;
  color: #5f6874;
  font-size: 16px;
  line-height: 1.85;
}

.advantage-action {
  margin-top: 0;
}

.online-course-tabs {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 18;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 0 auto;
  padding: 5px 0 calc(5px + env(safe-area-inset-bottom));
  border-top: 1px solid #dfe1e5;
  background: rgba(255, 255, 255, 0.98);
}

.online-course-tabs button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  border: none;
  background: transparent;
  color: #5f6670;
  font-size: 13px;
}

.online-course-tabs i {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  color: #fff;
  font-size: 14px;
  background: #8fd750;
}

.online-course-tabs button:nth-child(2) i {
  background: #ff8c22;
}

.online-course-tabs button:nth-child(3) i {
  background: #8bd44c;
}

.online-course-tabs button:nth-child(4) i {
  background: #35a8ea;
}

.online-course-tabs .is-active {
  color: #1f2937;
}

@media (max-width: 420px) {
  .online-course-hero {
    min-height: 214px;
  }

  .hero-board h1 {
    font-size: 31px;
  }

  .hero-board p {
    font-size: 18px;
  }

  .online-course-intro {
    padding: 62px 32px 40px;
  }

  .online-course-intro p {
    font-size: 17px;
  }

  .advantage-card {
    grid-template-columns: 52px minmax(0, 1fr);
    padding-right: 20px;
    padding-left: 20px;
  }

  .advantage-content h3 {
    font-size: 17px;
  }

  .advantage-content p {
    font-size: 15px;
  }
}
</style>
